const BILLING_TYPE = {
    CREDITS: 3,
    ESTIMATES: 1,
    ALL_INVOICES: 2,
    LOCKED_INVOICES: 10,
    OPEN_INVOICES: 9,
    REOPENED_INVOICES: 13,
    PAID_INVOICES: 11,
    LATE_FEES: 8,
    PAYMENTS: 4,
    REFUNDS: 6,
    RETURNS: 5,
    WRITE_OFFS: 7,
    DECLINED_ITEMS: 14
};

const CREDIT_PEER = {
    TYPE_DEPOSIT: 4,
    TYPE_RETURN: 5,
    TYPE_OTHER: 6,
    TYPE_DEPOSIT_OVERPAID: 7,
    TYPE_PAYMENT_OVERPAID: 8
};

const INVOICE = {
    TYPE_ESTIMATE: 0,
    TYPE_OPEN: 1,
    TYPE_PAID: 2,
    TYPE_WRITEOFF: 3,
    TYPE_CLOSED: 4,
    TYPE_LOCKED: 5,
    TYPE_REOPENED: 6,

    INVOICE_LIST_WITHOUT_PRICE: 1,
    INVOICE_LIST_WITHOUT_PRICE_LINK: 2
};

const INVOICE_LIST = {
    TYPE_NEW_INVOICE: "-1",
    TYPE_DO_NOT_INVOICE: "-4"
};

const CREDIT_TYPE = {
    1: "Client Relations",
    2: "Referral",
    3: "Promotion",
    4: "Deposit",
    5: "Return",
    6: "Other",
    7: "Deposit (Overpaid)",
    8: "Overpayment"
};

const INTEGRATED_PAYMENTS_TYPE = {
    NAME_CCONNECT_TERMINAL: "Credit Card On Terminal (CardConnect)",
    NAME_CCONNECT_KEY_IN: "Credit Card Keyed-in (CardConnect)",
    NAME_CCONNECT_CARD_ON_FILE: "Credit Card On File (CardConnect)",
    NAME_STRIPE_TERMINAL: "Credit Card On Terminal (Stripe)",
    NAME_STRIPE_KEY_IN: "Credit Card Keyed-in (Stripe)",
    NAME_STRIPE_CARD_ON_FILE: "Credit Card On File (Stripe)"
};

const DOCUMENT_TYPE = {
    RABIES: 1,
    VACCINE: 2,
    REMINDER: 3,
    INVOICE: 4,
    RECEIPT: 5,
    LETTER: 6,
    SOAP: 7,
    WELLNESS_PLAN: 8,
    TREATMENT: 9
};

const SOCKET_MATCHER = "payment:socket:matcher";

export const TEXT_INCLUDE_DECLINED_ITEMS =
    "Include declined items on the invoice";
export const TYPE_TABS_DECLINED_ITEM = 5;

export default {
    BILLING_TYPE,
    CREDIT_PEER,
    INVOICE,
    CREDIT_TYPE,
    INTEGRATED_PAYMENTS_TYPE,
    DOCUMENT_TYPE,
    SOCKET_MATCHER,
    INVOICE_LIST,
    TEXT_INCLUDE_DECLINED_ITEMS,
    TYPE_TABS_DECLINED_ITEM
};
